<template>
  <div class="reference-field">
    <div class="reference-field__title">
      <i2pu
        v-if="isI2pu"
        class="reference-field__i2pu"
        :is-bold="false"
      />
      {{ fieldName }}
    </div>
    <div
      class="reference-field__value"
      :class="backgroundHandler(status)"
    >
      <span>{{ parsedFieldValue }}</span>
    </div>
  </div>
</template>

<script>
import { MaintenanceStatus } from 'sigma-mappings';
import I2pu from '@/domain/components/installation/engineering/commutatorMaintenance/I2pu';
import exponentialFilter from '@/filters/exponentialFilter';
import { mapGetters } from 'vuex';

export default {
  name: 'CommutatorReferenceField',
  props: {
    fieldName: {
      type: String,
      default: '',
      required: true,
    },
    fieldValue: {
      type: [String, Number],
      default: '-',
    },
    status: {
      type: String,
    },
    isExponential: {
      type: Boolean,
      default: false,
    },
    isI2pu: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    I2pu,
  },
  computed: {
    ...mapGetters([
      'language',
    ]),
    formattedRawFieldValue() {
      const language = this.language.key;
      if (language === 'pt-BR' || language === 'es-ES') {
        return this.fieldValue.toString().replace('.', ',');
      }
      return this.fieldValue;
    },
    parsedFieldValue() {
      if (Number.isNaN(Number(this.fieldValue))) {
        return '-';
      }
      return Number(this.fieldValue) || '-';
    },
  },
  methods: {
    backgroundHandler(status) {
      const backgroundColors = {
        [MaintenanceStatus.IN_DAY]: 'reference-field__background--in-day',
        [MaintenanceStatus.DELAYED]: 'reference-field__background--delayed',
        [MaintenanceStatus.IMMINENT]: 'reference-field__background--imminent',
      };
      if (status) {
        return backgroundColors[status];
      }
      return 'reference-field__background';
    },
  },
  filters: {
    exponentialFilter,
  },
};

</script>
<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .reference-field
    display: flex
    flex-direction: row
    flex-wrap: nowrap
    align-items: center
    height: 2em
    padding: 0 5px
    margin: 5px 0
    &__title
      display: flex
      align-items: center
      justify-content: flex-end
      text-align: right
      width: 65%
      height: 95%
      font-size: 0.975em
      padding-right: 8px
    &__value
      position: relative
      color: $color-gray-intermediary
      height: 100%
      width: 35%
      padding-right: 3px
      display: flex
      align-items: center
      justify-content: flex-end
      border-radius: 3px
    &__background
      background: var(--color-background-light)
      &--in-day
        color: $color-gray-light
        font-weight: bold
        background: var(--color-primary)
      &--imminent
        color: $color-gray-light
        font-weight: bold
        background: var(--color-warning)
      &--delayed
        color: $color-gray-light
        font-weight: bold
        background: var(--color-danger)
    &__i2pu
      margin-right: 2px
      width: 25px
      height: 25px

  .manage-fonts_16px
    .reference-field
      &__title
        width: 60%
      &__value
        width: 40%

  .manage-fonts_18px
    .reference-field
      &__title
        width: 55%
      &__value
        width: 45%
</style>
